import { render } from "./ks-welcome-numbers-item.vue?vue&type=template&id=4fbe9db6"
import script from "./ks-welcome-numbers-item.vue?vue&type=script&lang=js"
export * from "./ks-welcome-numbers-item.vue?vue&type=script&lang=js"

import "./ks-welcome-numbers-item.vue?vue&type=style&index=0&id=4fbe9db6&lang=css"
script.render = render

export default script